import Logo from 'assets/icons/Logo';
import { TOAST } from 'constants/general';
import { POST_HOG_EVENT } from 'constants/events';
import AuthActionsWrapper from 'dashboard/auth/AuthActionsWrapper';
import AuthPageWrapper from 'dashboard/auth/AuthPageWrapper';
import ForgotPassword from 'dashboard/auth/ForgotPassword';
import SignIn from 'dashboard/auth/SignIn';
import SignUp from 'dashboard/auth/signup';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { capturePostHogEvent } from 'services/posthog.service';
import { t } from 'services/i18n.service';
import { trackReferralSource } from 'utils/referral-tracking.util';
import LanguageDropDown from 'components/LanguageDropDown';
import ThemeToggle from 'components/ui/ThemeToggle';
import { THEME_TOGGLE_VARIANT } from 'enums';

function AuthPage() {
  // Track when users first land on the auth page and check for referrals
  useEffect(() => {
    capturePostHogEvent(POST_HOG_EVENT.AUTH_PAGE.LANDED);

    // Track referral sources (landing page, external sites, UTM params, etc.)
    trackReferralSource();
  }, []);

  return (
    <AuthPageWrapper>
      <div className='absolute top-4 right-4 z-10 flex gap-2'>
        <ThemeToggle variant={THEME_TOGGLE_VARIANT.ICON_ONLY} size='sm' />
        <LanguageDropDown />
      </div>
      <section className='w-full lg:w-[40%] h-fit flex-col ~gap-2/5 items-center justify-center ~p-2/5 hidden md:flex'>
        <Logo />
        <h1 className='w-fit ~text-xl/4xl font-semibold text-primary-900 dark:text-primary-dark-500 text-center'>
          {t('make_deep_work')}
        </h1>
      </section>
      <AuthActionsWrapper>
        <SignIn />
        <SignUp />
        <ForgotPassword />
      </AuthActionsWrapper>
      <ToastContainer
        limit={TOAST.LIMIT}
        draggable={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        autoClose={TOAST.AUTO_CLOSE.DEFAULT}
      />
    </AuthPageWrapper>
  );
}

export default AuthPage;
